export interface CellData {
  rowIndex: number;
  columnIndex: number;
  value: number;
}

export interface Column {
  playersFrom: number;
  playersTo: number;
  percentages: number[];
}

export interface Row {
  rankFrom: number;
  rankTo: number;
}

export interface PayoutStructure {
  playersColumns: Column[];
  rankRows: Row[];
}

export interface PayoutStructureState extends PayoutStructure {
  name?: string;
  isDirty: boolean;
  validationErrors: Record<string, string>;
}
